// extracted by mini-css-extract-plugin
module.exports = {"wrap":"footer_wrap__3oHeW","wrapTitle":"footer_wrapTitle__2fu4j","contact_text":"footer_contact_text__oH2o4","text":"footer_text__38_sQ","copy":"footer_copy__3RvFu"};